<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtit">L<span class="chsmall">IST OF</span> M<span class="chsmall">APS</span></h2>
<p class="fmp"><a href="#/xhtml/12_Federhens_Introduction#map_1">1.</a> Locations referenced in Federhen’s narrative</p>
<p class="fmp"><span href="#/xhtml/16_Chapter4#map_2" title="Link target outside of Sample">2.</span> Camp Ford</p>
<p class="fmp"><span href="#/xhtml/16_Chapter4#map_3" title="Link target outside of Sample">3.</span> Camp Ford, as depicted in The Camp Newspaper “<em class="italic">The Old Flag“</em> (March 1, 1864)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_List_of_maps.vue?7eb1fcdf